import { Injectable } from "@angular/core";
import { Firebase } from "@ionic-native/firebase";
import { Platform } from "ionic-angular";
import { Storage } from "@ionic/storage";
import { Observable } from "rxjs";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class FCM {
  constructor(
    public firebaseNative: Firebase,
    public storage: Storage,
    private platform: Platform
  ) {}

  // Get permission from the user
  async getToken(userId, topic) {
    let token;

    if (this.platform.is("cordova")) {
      if (this.platform.is("android")) {
        token = await this.firebaseNative.getToken();
      }

      if (this.platform.is("ios")) {
        token = await this.firebaseNative.getToken();
        await this.firebaseNative.grantPermission();
      }

      await this.firebaseNative.subscribe(topic);
      if (userId) {
        await this.firebaseNative.subscribe(userId);
      }
    }

    return this.saveTokenToStorage(token);
  }

  // Save the token to storage
  private saveTokenToStorage(token) {
    if (!token) return;
    return this.storage.set("token", token);
  }

  // Listen to incoming FCM messages
  listenToNotifications() {
    if (this.platform.is("cordova")) {
      return this.firebaseNative.onNotificationOpen();
    } else {
      return Observable.create((observer) => {});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/fcm/fcm.ts